import { Input, Modal } from 'antd';
import * as Hangul from 'hangul-js';
import _ from 'lodash';
import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { httpGet, httpUrl } from '../../api/httpClient';
import KeyInputModal from '../../components/modal/KeyInputModal';
import Const from '../../const';
import '../../css/modal.scss';
import { getJibunAddress, setJibunAddress } from '../../lib/module';
import { branchAddressSearchKeyword } from '../../lib/util/codeUtil';
import ClickSwitch from '../input/ClickSwitch';
import image from '../../res/image';
import {modalStyle} from "../../lib/util/codeUtil";

const pageSize = 20;

class AddressModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dong: [{ idx: 0, name: '전체' }],
      address: '',
      keyInputModalOpen: false,
      selectedDong: { idx: 0, name: '전체' },
      tableData: [],
      tableDataCurrent: 0,
      tableDataCurrent2: 0,
      addrTableEnd: false,
      tableDataEnd: false,
      errorMessage: '',
      branchName: '',
      useSimpleDong: true,
      getJibunAddr: getJibunAddress() === undefined ? true : getJibunAddress(),
    };
  }

  componentDidMount() {
    this.initializeComponent();
    this.getBranchInfo();
  }

  componentDidUpdate() {
  }

  initializeComponent = () => {
    let addrDeliveryData = reactLocalStorage.getObject(
      Const.appName + '#addrDelivery'
    );
    addrDeliveryData.forEach((item) => {
      item.name = item.eupMyeonDong;
      item.siDo = item.siDo;
      item.siGunGu = item.siGunGu;
    });

    let getSelectSimpleDong = reactLocalStorage.getObject(
      Const.appName + '#selectSimpleDong'
    );
    if (getSelectSimpleDong.length > 0) {
      let listIdx = getSelectSimpleDong.map((x) => x.idx);
      let list = addrDeliveryData.filter((x) => !listIdx.includes(x.idx));

      this.setState({
        address: '',
        keyInputModalOpen: false,
        selectedDong: { idx: 0, name: '전체' },
        tableData: [],
        tableDataCurrent: 0,
        tableDataCurrent2: 0,
        tableDataEnd: false,
        errorMessage: '',
        dong: this.state.dong.concat(list),
      });
    } else {
      this.setState({
        address: '',
        keyInputModalOpen: false,
        selectedDong: { idx: 0, name: '전체' },
        tableData: [],
        tableDataCurrent: 0,
        tableDataCurrent2: 0,
        tableDataEnd: false,
        errorMessage: '',
        dong: [
          { idx: 0, name: '전체', siDo: '', siGunGu: '' },
          ...addrDeliveryData,
        ],
      });
    }
    this.onSearch();
  };

  onSearch = () => {
    this.setState(
      {
        tableData: [],
        tableDataCurrent: 0,
        tableDataCurrent2: 0,
        tableDataEnd: false,
        addrTableEnd: false,
        errorMessage: '',
      },
      () => {
        this.findAddress();
      }
    );
  };

  openKeyInputModal = () => {
    this.setState({ keyInputModalOpen: true });
  };
  closeKeyInputModal = () => {
    this.setState({ keyInputModalOpen: false });
  };

  parseRegexExpressions = (string) => {
    string = string
      .replace(/&amp;/gi, '&')
      .replace(/&quot;/gi, '"')
      .replace(/&apos;/gi, "'")
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>');
    return string.substring(1, string.length - 1);
  };

  findAddress = () => {

    if (this.state.tableDataEnd) return;
    if (this.state.addrTableEnd) {
      this.findAddressAll();
    } else {
      this.findAddressEx();
      this.getAddrBookmark();
    }
  };

  findAddressAll = () => {
    // const confmKey = "U01TX0FVVEgyMDIxMDQxMDIzMjg0MDExMTAzNDk=";
    const currentPage = parseInt(this.state.tableDataCurrent2) + 1;
    const countPerPage = pageSize;
    const keyword =
      (this.state.selectedDong.idx === 0
        ? this.state.branchName
        : this.state.selectedDong.siDo) +
      ' ' +
      (this.state.selectedDong.idx === 0
        ? ''
        : this.state.selectedDong.siGunGu) +
      ' ' +
      (this.state.selectedDong.idx === 0 ? '' : this.state.selectedDong.name) +
      ' ' +
      (this.state.address ? this.state.address : '');
    // const resultType = "json";
    // const url =
    //   "https://www.juso.go.kr/addrlink/addrLinkApiJsonp.do?" +
    //   "confmKey=" +
    //   confmKey +
    //   "&currentPage=" +
    //   currentPage +
    //   "&countPerPage=" +
    //   countPerPage +
    //   "&keyword=" +
    //   keyword +
    //   "&resultType=" +
    //   resultType;

    // Axios({
    //   method: "GET",
    //   url: url,
    //   headers: {
    //     Accept: "application/json",
    //     "Content-Type": "application/json",
    //   },
    // })
    if (keyword.trim() === '') {
      this.setState({ tableDataEnd: true, errorMessage: '' });
      return;
    }
    httpGet(httpUrl.getAddress, [currentPage, countPerPage, keyword], {})
      .then((response) => {
        if (response.data.type === 'juso') {
          const results = JSON.parse(
            this.parseRegexExpressions(response.data.json)
          ).results;
          if (results.juso == null) {
            this.setState({ errorMessage: results.common.errorMessage });
          } else {
            let tableData = results.juso;
            if (results.juso.length === 0) {
              this.setState({ tableDataEnd: true, errorMessage: '' });
              return;
            }
            if (this.state.tableDataCurrent2 === results.common.currentPage) {
              tableData = [];
            }

            this.setState({
              tableData: this.state.tableData.concat(tableData),
              tableDataCurrent2: results.common.currentPage,
              errorMessage: '',
            });
          }
        } else {
          const results = JSON.parse(response.data.json).results;
          if (results.length === 0) {
            this.setState({
              tableDataEnd: true,
              errorMessage: '검색 결과가 존재하지 않습니다.',
            });
            return;
          }

          let tableData = results.map((row) => ({
            bdNm: '',
            roadAddr: row.도로명주소,
            jibunAddr: row.지번주소,
          }));
          if (this.state.tableDataCurrent2 === 2) {
            tableData = [];
          }

          this.setState({
            tableData: this.state.tableData.concat(tableData),
            // tableDataCurrent2: 2,
            errorMessage: '',
          });
        }
      })
      .catch((e) => {
        this.setState({ errorMessage: 'error' });
      });
  };

  findAddressEx = () => {
    const searchDong =
      this.state.selectedDong.idx === 0 ? '' : this.state.selectedDong.name;
    const searchString = this.state.address ? this.state.address : '';
    httpGet(
      httpUrl.addrExList,
      [
        pageSize,
        parseInt(this.state.tableDataCurrent) + 1,
        searchDong,
        searchString,
      ],
      {}
    )
      .then((res) => {
        if (res.result === 'SUCCESS') {
          if (res.data.addrAptBranches.length < pageSize) {
            this.setState({ addrTableEnd: true, errorMessage: '' }, () =>
              this.findAddress()
            );
          }
          if (this.state.tableDataCurrent === res.result.currentPage) {
            res.result.addrAptBranches = [];
          }

          const tableData = res.data.addrAptBranches.map((row) => ({
            name: row.name,
            roadAddr: row.addr1,
            jibunAddr: row.addr3,
          }));

          this.setState({
            tableData: this.state.tableData.concat(tableData),
            tableDataCurrent: res.data.currentPage,
            errorMessage: '',
          });
        }
      })
      .catch((e) => {
        this.setState({ errorMessage: 'error' });
      });
  };

  getBranchInfo = () => {
    httpGet(
      httpUrl.getBranchInfo,
      [this.props.loginReducer.loginInfo.branchIdx],
      {}
    ).then((res) => {
      if (res.result === 'SUCCESS') {
        const branchName = res.data.branchName;
        Object.keys(branchAddressSearchKeyword).forEach((key) => {
          branchAddressSearchKeyword[key].forEach((branchKey) => {
            const re = new RegExp(branchKey);
            const res = branchName.match(re);
            if (res) this.setState({ branchName: key });
            return;
          });
        });
      }
    });
  };

  getAddrBookmark = () => {
    let bookmarkList = [];
    let bookmarkStorage = reactLocalStorage.getObject(
      Const.appName + '#addrBookmark'
    );

    if (Object.keys(bookmarkStorage).length != 0)
      bookmarkList = bookmarkStorage;

    this.setState({
      tableData: this.state.tableData.concat(bookmarkList),
    });

    return bookmarkList;
  };

  registAddrBookmark = (row) => {
    let self = this;
    let bookmarkList = this.getAddrBookmark();

    if (
      bookmarkList.filter((item) => item.roadAddr === row.roadAddr).length !== 0
    ) {
      Modal.confirm({
        content: '즐겨찾기를 해제하시겠습니까?',
        okText: '확인',
        cancelText: '취소',
        ...modalStyle,
        onOk() {
          bookmarkList = bookmarkList.filter(
            (item) => item.roadAddr !== row.roadAddr
          );
          reactLocalStorage.setObject(
            Const.appName + '#addrBookmark',
            bookmarkList
          );
          self.setState(
            {
              tableData: self.state.tableData.concat(bookmarkList),
            },
            () => self.onSearch()
          );
        },
      });
    } else {
      let newBookmark = {
        name: row.name ? '즐겨찾기/' + row.name : '즐겨찾기',
        roadAddr: row.roadAddr,
        jibunAddr: row.jibunAddr,
      };

      bookmarkList.push(newBookmark);

      Modal.confirm({
        content: '해당 주소를 즐겨찾기 등록하시겠습니까?',
        okText: '확인',
        cancelText: '취소',
        ...modalStyle,
        onOk() {
          reactLocalStorage.setObject(
            Const.appName + '#addrBookmark',
            bookmarkList
          );
          self.setState(
            {
              tableData: self.state.tableData.concat(bookmarkList),
            },
            () => self.onSearch()
          );
        },
      });
    }
  };

  render() {
    const { isOpen, close } = this.props;

    return (
      <React.Fragment>
        {isOpen ? (
          <React.Fragment>
            <div className="Modal-addr-overlay" onClick={close} />
            <div className="Modal-addr">
              <div className="addr-modal-container">
                <div className="addr-modal-left-wrap">
                  <div className="addr-left mobileoff">배송 가능한 동</div>
                  <div className="addr-content-left-menu mobileoff">
                    {this.state.dong.map((row, index) => {
                      if (row.idx != 0 && !row.quickMenu) return <></>;
                      else
                        return (
                          <div
                            key={index}
                            className={
                              'addr-content-left-menu-text' +
                              (this.state.selectedDong.idx === row.idx
                                ? ' active'
                                : '')
                            }
                            onClick={() => {
                              this.onSearch();
                              this.setState({ selectedDong: row });
                            }}>
                            {row.name}
                          </div>
                        );
                    })}
                  </div>
                </div>

                <div className="addr-modal-right-wrap">
                  <div className="addr-title">
                    <div>
                      <div className="addr-content-title-text-color">
                        주소검색
                      </div>
                      <Link
                        to={{
                          pathname: '/setting',
                          state: {
                            useSimpleDong: this.state.useSimpleDong,
                          },
                        }}
                        className="addr-setting-btn mobileoff">
                        간편동 설정
                      </Link>
                      <div
                        style={{
                          fontSize: '20px',
                          fontWeight: 'bold',
                          padding: '2px',
                          marginLeft: '10px',
                        }}>
                        지번주소설정
                      </div>
                      <div>
                        <ClickSwitch
                          flag={this.state.getJibunAddr}
                          onChange={(flag) => {
                            this.setState({ getJibunAddr: flag });
                            setJibunAddress(flag);
                          }}
                        />
                      </div>
                    </div>
                    <img
                      style={{ display: 'inline' }}
                      src={image.closeIcon}
                      onClick={close}
                      className="addr-image"
                      alt=""
                    />
                  </div>

                  <div className="addr-content-main">
                    <div className="addr-content-main-all">
                      <div className="addr-content-main-input">
                        <Input
                          id="addr-input"
                          placeholder={
                            '도로명이나 읍면동/건물/번지수를 입력해주세요.'
                          }
                          onFocus={this.openKeyInputModal}
                          autoComplete="off"
                          value={this.state.address}
                          onChange={(e) =>
                            this.setState({ address: e.target.value })
                          }
                          onPressEnter={() => {
                            this.onSearch();
                          }}
                        />
                      </div>
                      <div className="mainKeypad-addrModal desk">
                        <KeyInputModal
                          isOpen={this.state.keyInputModalOpen}
                          close={this.closeKeyInputModal}
                          keyin={(data) => {
                            const str = this.state.address;
                            this.setState({
                              address: str
                                ? Hangul.assemble([
                                    ...Hangul.disassemble(str),
                                    data,
                                  ])
                                : data + '',
                            });
                          }}
                          backspace={() => {
                            const str = this.state.address;
                            this.setState({
                              address: str ? str.substr(0, str.length - 1) : '',
                            });
                          }}
                          ok={() => {
                            this.setState({ keyInputModalOpen: false });
                            this.onSearch();
                          }}
                        />
                      </div>
                      <div className="mainKeypad-addrModal pos">
                        <KeyInputModal
                          isOpen={this.state.keyInputModalOpen}
                          close={this.closeKeyInputModal}
                          keyin={(data) => {
                            const str = this.state.address;
                            this.setState({
                              address: str
                                ? Hangul.assemble([
                                    ...Hangul.disassemble(str),
                                    data,
                                  ])
                                : data + '',
                            });
                          }}
                          backspace={() => {
                            const str = this.state.address;
                            this.setState({
                              address: str ? str.substr(0, str.length - 1) : '',
                            });
                          }}
                          ok={() => {
                            this.setState({ keyInputModalOpen: false });
                            this.onSearch();
                          }}
                        />
                      </div>
                      <div className="addr-content-main-btn">
                        <img
                          style={{ display: 'inline' }}
                          src={image.SearchIcon}
                          className="addr-img"
                          onClick={() => this.onSearch()}
                          alt=""
                        />
                      </div>
                      <div className="addr-content-main-btn2 mobileoff">
                        <img
                          style={{ display: 'inline' }}
                          src={image.KeyboardIcon}
                          className="addr-img"
                          onClick={() => {
                            this.openKeyInputModal();
                          }}
                          alt=""
                        />
                      </div>
                      <div className="addr-content-main-block">
                        <div className="addr-content-main-block-menu">
                          <div className="addr-content-main-block-menu-text">
                            {this.state.getJibunAddr ? "지번주소" : "도로명주소" }
                          </div>
                        </div>
                        {this.state.errorMessage && (
                          <div style={{ textAlign: 'center', padding: '50px' }}>
                            {this.state.errorMessage}
                          </div>
                        )}
                        <div className="mobileoff">
                          {!this.state.errorMessage && (
                            <InfiniteScroll
                              dataLength={this.state.tableData.length}
                              next={this.findAddress}
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }} //To put endMessage and loader to the top.
                              hasMore={!this.state.tableDataEnd}
                              height={'calc(80vh - 200px)'}>
                              {_.uniqBy(this.state.tableData, 'roadAddr').map(
                                (row, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className={
                                        'addr-content-main-block-field' +
                                        (index % 2 === 0 ? '' : ' odd')
                                      }
                                      style={{ flex: 1 }}>
                                      <div
                                        onClick={() => {
                                          this.props.setAddress(row);
                                          this.props.callback && this.props.callback(
                                            this.state.getJibunAddr
                                          );
                                        }}
                                        style={{ flex: 0.98 }}>
                                        <div className="addr-content-main-block-field-text">
                                          {typeof row.name !== 'undefined' &&
                                            '[' + row.name + '] '}
                                          {this.state.getJibunAddr
                                            ? row.jibunAddr
                                            : row.roadAddr}
                                        </div>
                                      </div>
                                      <div className="addr-content-main-block-field-text2">
                                        <img
                                          style={{ display: 'inline' }}
                                          src={
                                            typeof row.name !== 'undefined' &&
                                            row.name.includes('즐겨찾기')
                                              ? image.StarIcon
                                              : image.Star2Icon
                                          }
                                          className="body-bookmark"
                                          alt=""
                                          onClick={() =>
                                            this.registAddrBookmark(row)
                                          }
                                        />
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </InfiniteScroll>
                          )}
                        </div>
                        <div className="mobile">
                          {!this.state.errorMessage && (
                            <InfiniteScroll
                              dataLength={this.state.tableData.length}
                              next={this.findAddress}
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }} //To put endMessage and loader to the top.
                              hasMore={!this.state.tableDataEnd}
                              height={150}>
                              {this.state.tableData.map((row, index) => {
                                return (
                                  <div
                                    key={index}
                                    className={
                                      'addr-content-main-block-field' +
                                      (index % 2 === 0 ? '' : ' odd')
                                    }
                                    onClick={() => this.props.setAddress(row)}>
                                    <div className="addr-content-main-block-field-text">
                                      {typeof row.name !== 'undefined' &&
                                        '[' + row.name + '] '}
                                      {row.roadAddr}
                                    </div>
                                    <div className="addr-content-main-block-field-text2">
                                      ({row.jibunAddr})
                                    </div>
                                  </div>
                                );
                              })}
                            </InfiniteScroll>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginReducer } = state;
  return { loginReducer };
};

const mapDispatchToProps = {};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddressModal)
);
